import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/cotacao/dados-pessoais",
      name: "dados-pessoais",
      component: () => import("./views/PersonalDataView.vue")
    },
    {
      path: "/cotacao/endereco",
      name: "endereco",
      component: () => import("./views/AddressDataView.vue")
    },
    {
      path: "/cotacao/dados-financeiros",
      name: "dados-financeiros",
      component: () => import("./views/FinancialDataView.vue")
    },
    {
      path: "/cotacao/enviada",
      name: "cotacao-enviada",
      component: () => import("./views/FinishingQuotation.vue")
    },
    {
      path: "/sobre-servico",
      name: "about-service",
      component: () => import("./views/AboutService.vue")
    },
    {
      path: "/sobre-beneficios",
      name: "about-benefits",
      component: () => import("./views/AboutBenefits.vue")
    },
    {
      path: "/sobre-coberturas",
      name: "about-protection",
      component: () => import("./views/AboutProtections.vue")
    },
    {
      path: "/sobre-como-contratar",
      name: "about-how-contract",
      component: () => import("./views/AboutHowContract.vue")
    },
    {
      path: "/termos-e-condicoes",
      name: "therms",
      component: () => import("./views/ThermsConditions.vue")
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
